import { gql } from "@apollo/client";

export default gql`
  mutation toggleTopicStateMutation($topicId: Int!, $state: TopicState!) {
    createOrUpdateTopic(topicId: $topicId, state: $state) {
      topic {
        id
        state
      }
    }
  }
`;
